import React, { useReducer, useState, useEffect, act } from 'react';
import { useNavigate } from 'react-router-dom'
import Datepicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css';
import SelectCab from './SelectCab';
import { Link } from 'react-router-dom';


const BookingForm = () => {
    const [ setState] = useState({
        from: '',
        to: '',
        distance: 0,
        fare: 0,
        triptype: '',
    });

    const citie = [
        {
            _id: 'city1',
            distance: { city2: 120, city3: 200 },
        },
        {
            _id: 'city2',
            distance: { city1: 120, city3: 80 },
        },
    ];

    const InitialState = {
        triptype: "Outstation",
        from: "",
        to: "",
        PickUpdate: new Date(),
        pickUpTime: '',
        pickUpLocation: "",
        returndate: new Date(),
        ReturnTime: "",
        returnLocation: "",
        package: "",
        visitingPlaces: [""],
        NumberOfPersons: "",
        CabType: "",
        name: "",
        mobile: "",
        mail: "",
        distance: "",
        fare: "",
        LocalTripType: "Hour-Basis",
        selectedCab:null
    };

    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    // const fetchCities = async () => {
    //     try {
    //         let apiUrl = `http://localhost:3800/api/v1/cities`;
    //         fetch(apiUrl)
    //             .then((res) => res.json())
    //             .then((json) => {
    //                 if(json.success === true) {
                        
    //                     setCities(json.tour)
    //                 }
    //             });
    const fetchCities = async () => {
  try {
    const apiUrl = "http://localhost:1000/api/v1/cities";
    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const json = await response.json();

    if (json.success === true) {
      setCities(json.tour); // assuming setCities is available in the scope
    } else {
      console.error("API call succeeded but returned success: false", json);
    }
  } catch (error) {
    console.error("Failed to fetch cities:", error.message);
  }
};

    //     } catch (error) {
    //         console.error('Error fetching cities:', error);
    //     }
    // };

    const reducer = (state, action) => {
        switch (action.type) {
            case "TRIP-TYPE":
                return {
                    triptype: capitalizeFirstLetter(action.payload),
                    from: "",
                    to: "",
                    PickUpdate: new Date(),
                    pickUpTime: '',
                    pickUpLocation: "",
                    returndate: new Date(),
                    ReturnTime: "",
                    returnLocation: "",
                    package: "",
                    visitingPlaces: [""],
                    NumberOfPersons: "",
                    CabType: "",
                    name: "",
                    mobile: "",
                    mail: "",
                    distance: "",
                    fare: "",
                    LocalTripType: "",
                    selectedCab: null,
                    cities: []
                }
            case "FROM":
                return { ...state, from: state.triptype === "Outstation" ? action.payload : capitalizeFirstLetter(action.payload) };
            case "TO":
                return { ...state, to: state.triptype === "Outstation" ? action.payload : capitalizeFirstLetter(action.payload) };
            case "PICK-UP-DATE":
                console.log(action.payload);
                return { ...state, PickUpdate: action.payload };
            case "RETURN-DATE":
                console.log(action.payload);
                
                return { ...state, returndate: action.payload};
            case "NAME":
                return { ...state, name: capitalizeFirstLetter(action.payload) };
            case "MOBILE":
                return { ...state, mobile: action.payload };
            case "MAIL":
                return { ...state, mail: action.payload };
            case "PICK-UP-LOCATION":
                return { ...state, pickUpLocation: capitalizeFirstLetter(action.payload) };
            case "PICK-UP-TIME":
                return { ...state, pickUpTime: action.payload};
            case "RETURN-LOCATION":
                return { ...state, returnLocation: capitalizeFirstLetter(action.payload)};
            case "RETURN-TIME":
                return { ...state, ReturnTime: action.payload };
            case "ADD-VISITING-PLACE":
                return { ...state, visitingPlaces: [...state.visitingPlaces, ""] };
            case "REMOVE-VISITING-PLACE":
                return { ...state, visitingPlaces: state.visitingPlaces.filter((_, index) => index !== action.payload) };
            case "UPDATE-VISITING-PLACE":
                const updatedVisitingPlaces = state.visitingPlaces.map((place, index) =>
                    index === action.payload.index ? capitalizeFirstLetter(action.payload.value) : place
                );
                return { ...state, visitingPlaces: updatedVisitingPlaces };
            case "NUMBER-OF-PERSONS":
                return { ...state, NumberOfPersons: action.payload };
            case "CAB-TYPE":
               
                return { ...state, CabType: capitalizeFirstLetter(action.payload) };
              
                
            case "LOCAL-TRIP-TYPE":
                return { ...state, LocalTripType: capitalizeFirstLetter(action.payload) };
            case "DISTANCE":
                return { ...state, distance: action.payload };
            case "FARE":
                console.log("Fare:", action.payload)
                return { ...state, fare: action.payload };
            case "SELECTED-CAB":
                return{...state, selectedCab: action.payload};
            case 'FARE':
                return { ...state, fare: action.payload };
                      
            default:
                return state;
        }
    };
    

    const computeFare = (distance, selectedCab) => {
        try {
            let fare = parseInt(distance) * parseInt(selectedCab.kmPrice) + parseInt(selectedCab.price);
            return fare;
        } catch (error) {
            return "Price not available";
        }
    }

    const [state, dispatch] = useReducer(reducer, InitialState);
    const [error, setError] = useState("");
    const [cities, setCities] = useState([]);
    
    

    useEffect(() => {
        fetchCities();
    },[]);
    // useEffect(() => {
    //     if (state.triptype && state.triptype === "Outstation") {
    //         if(state.from && state.from != "" && state.to && state.to != "") {
    //             const distance = cities
    //                 .filter((city) => city._id == state.from)
    //                 .map((city) => city.distance[state.to]);
    //             dispatch({ type: "DISTANCE", payload: distance });
    //             if(state.selectedCab) {
    //                 const fare = computeFare(state.distance, state.selectedCab);
    //                 console.log("Dispatching Fare:", fare)
    //                 dispatch({ type: "FARE", payload: fare });
    //             }
    //         }
    //     }
    // }, [state.triptype, state.from, state.to, state.selectedCab]);

    const navigate = useNavigate()
    const FormSubmit = (e) => {
        e.preventDefault();

        if (!state.triptype) {
            setError("Please Select The TripType")
            return
        }
        setError("")


        navigate("/confirmbooking", { state: { ...state,PickUpdate: state.PickUpdate.toLocaleDateString(), returndate: state.returndate.toLocaleDateString() } })


    };

    const handleDistanceChange = (e) => {
        console.log(state, e)
        if(state.triptype === "Outstation" && e == null) {
            if(state.from && state.from != "" && state.to && state.to != "") {
                try {
                    this.cities
                    .find((city) => city._id === state.from)
                    .map((city) => {
                        dispatch({ type: "DISTANCE", payload: city.distance[state.to] }); 
                    });
                } catch (err) {
                    // Unable to compute distance at the moment, no problem
                }
            }  
        } else if(e!=null) {
            const distance = e.target.value;
            dispatch({ type: "DISTANCE", payload: distance });
        }
        // const fare = calculateFare(parseFloat(distance) || 0);
        // dispatch({ type: "FARE", payload: fare });
    
// Handler for distance input

    const handleDistanceChanges = (e) => {
        if (state.triptype === "Outstation" && e == null) {
            if (state.from && state.from !== "" && state.to && state.to !== "") {
                try {
                    const fromCity = cities.find((city) => city._id === state.from);
                    if (fromCity && fromCity.distance[state.to]) {
                        const calculatedDistance = fromCity.distance[state.to];
                        setState(prev => ({
                            ...prev,
                            distance: calculatedDistance,
                        }));
                    }
                } catch (err) {
                    console.error("Error finding distance:", err);
                }
            }
        } else if (e != null) {
            const distance = e.target.value;
            setState(prev => ({
                ...prev,
                distance: parseFloat(distance) || 0,
            }));
        }
    };
};
// Add this useEffect in your component to auto-calculate distance
useEffect(() => {
    if (state.triptype === 'Outstation' && state.from && state.to && state.from !== state.to) {
        // Replace this mock with your actual logic or API call to get distance
        const fromCity = cities.find(city => city._id === state.from);
        const toCity = cities.find(city => city._id === state.to);

        if (fromCity && toCity) {
            // Sample mock logic - replace with real calculation or API response
            const calculatedDistance = Math.floor(Math.random() * 500) + 50; // dummy distance between 50-550 km
            dispatch({ type: 'DISTANCE', payload: calculatedDistance });
        }
    }
}, [state.from, state.to, state.triptype, cities, dispatch]);

// useEffect(() => {
//     if (state.triptype === 'Outstation' && state.from && state.to && state.from !== state.to) {
//       // Example distance calculation logic (replace with real logic/API)
//       const calculatedDistance = Math.floor(Math.random() * 500) + 50;
//       dispatch({ type: 'DISTANCE', payload: calculatedDistance });
//     }
//   }, [state.from, state.to, state.triptype]);
  

  const statesWithCities = {
    "Tamil Nadu": [
    { _id: "tn-chennai", display_name: "Chennai" },
    { _id: "tn-coimbatore", display_name: "Coimbatore" },
    { _id: "tn-kanchipuram", display_name: "Kanchipuram" },
    { _id: "tn-tiruvallur", display_name: "Tiruvallur" },
    { _id: "tn-vellore", display_name: "Vellore" },
    { _id: "tn-cuddalore", display_name: "Cuddalore" },
    { _id: "tn-viluppuram", display_name: "Viluppuram" },
    { _id: "tn-tiruvannamalai", display_name: "Tiruvannamalai" },
    { _id: "tn-thanjavur", display_name: "Thanjavur" },
    { _id: "tn-tiruchirappalli", display_name: "Tiruchirappalli" },
    { _id: "tn-perambalur", display_name: "Perambalur" },
    { _id: "tn-pudukkottai", display_name: "Pudukkottai" },
    { _id: "tn-nagapattinam", display_name: "Nagapattinam" },
    { _id: "tn-thiruvarur", display_name: "Thiruvarur" },
    { _id: "tn-karaikal", display_name: "Karaikal" },
    { _id: "tn-madurai", display_name: "Madurai" },
    { _id: "tn-ramanathapuram", display_name: "Ramanathapuram" },
    { _id: "tn-virudhunagar", display_name: "Virudhunagar" },
    { _id: "tn-thoothukudi", display_name: "Thoothukudi" },
    { _id: "tn-dindigul", display_name: "Dindigul" },
    { _id: "tn-sivagangai", display_name: "Sivagangai" },
    { _id: "tn-tenkasi", display_name: "Tenkasi" },
    { _id: "tn-kanniyakumari", display_name: "Kanniyakumari" },
    { _id: "tn-tirunelveli", display_name: "Tirunelveli" },
    { _id: "tn-rajapalayam", display_name: "Rajapalayam" },
    { _id: "tn-namakkal", display_name: "Namakkal" },
    { _id: "tn-salem", display_name: "Salem" },
    { _id: "tn-erode", display_name: "Erode" },
    { _id: "tn-karur", display_name: "Karur" },
    { _id: "tn-trichy", display_name: "Trichy" },
    { _id: "tn-chengalpattu", display_name: "Chengalpattu" },
    { _id: "tn-tiruppur", display_name: "Tiruppur" },
    { _id: "tn-dharmapuri", display_name: "Dharmapuri" },
    { _id: "tn-krishnagiri", display_name: "Krishnagiri" },
    { _id: "tn-ariyalur", display_name: "Ariyalur" }
    ],
    "Kerala": [
      { _id: "kl-thiruvananthapuram", display_name: "Thiruvananthapuram" },
      { _id: "kl-kollam", display_name: "Kollam" },
      { _id: "kl-pathanamthitta", display_name: "Pathanamthitta" },
      { _id: "kl-alappuzha", display_name: "Alappuzha" },
      { _id: "kl-kottayam", display_name: "Kottayam" },
      { _id: "kl-idukki", display_name: "Idukki" },
      { _id: "kl-ernakulam", display_name: "Ernakulam" },
      { _id: "kl-thrissur", display_name: "Thrissur" },
      { _id: "kl-palakkad", display_name: "Palakkad" },
      { _id: "kl-malappuram", display_name: "Malappuram" },
      { _id: "kl-kozhikode", display_name: "Kozhikode" },
      { _id: "kl-wayanad", display_name: "Wayanad" },
      { _id: "kl-kannur", display_name: "Kannur" },
      { _id: "kl-kasaragod", display_name: "Kasaragod" }
    ],
    "Andhra Pradesh": [
    { _id: "ap-anantapur", display_name: "Anantapur" },
    { _id: "ap-chittoor", display_name: "Chittoor" },
    { _id: "ap-east-godavari", display_name: "East Godavari" },
    { _id: "ap-guntur", display_name: "Guntur" },
    { _id: "ap-kadapa", display_name: "Kadapa (Cuddapah)" },
    { _id: "ap-krishna", display_name: "Krishna" },
    { _id: "ap-kurnool", display_name: "Kurnool" },
    { _id: "ap-prakasam", display_name: "Prakasam" },
    { _id: "ap-srikakulam", display_name: "Srikakulam" },
    { _id: "ap-visakhapatnam", display_name: "Visakhapatnam" },
    { _id: "ap-vizianagaram", display_name: "Vizianagaram" },
    { _id: "ap-west-godavari", display_name: "West Godavari" },
    { _id: "ap-sri-potti-sriramulu-nellore", display_name: "Sri Potti Sriramulu Nellore" },
    { _id: "ap-annamayya", display_name: "Annamayya" },
    { _id: "ap-bapatla", display_name: "Bapatla" },
    { _id: "ap-kakinada", display_name: "Kakinada" },
    { _id: "ap-konaseema", display_name: "Konaseema" },
    { _id: "ap-ntr", display_name: "NTR (Nandamuri Taraka Rama Rao)" },
    { _id: "ap-palnadu", display_name: "Palnadu" },
    { _id: "ap-rajamahendravaram", display_name: "Rajamahendravaram" },
    { _id: "ap-srikakulam", display_name: "Srikakulam" },
    { _id: "ap-tirupati", display_name: "Tirupati" },
    { _id: "ap-uppalapadu", display_name: "Uppalapadu" }
    ],
    "Karnataka": [
      { _id: "ka-bagalkot", display_name: "Bagalkot" },
      { _id: "ka-ballari", display_name: "Ballari (Bellary)" },
      { _id: "ka-belagavi", display_name: "Belagavi (Belgaum)" },
      { _id: "ka-bengaluru-rural", display_name: "Bengaluru Rural" },
      { _id: "ka-bengaluru-urban", display_name: "Bengaluru Urban" },
      { _id: "ka-bidar", display_name: "Bidar" },
      { _id: "ka-chamarajanagar", display_name: "Chamarajanagar" },
      { _id: "ka-chikkaballapur", display_name: "Chikkaballapur" },
      { _id: "ka-chikkamagaluru", display_name: "Chikkamagaluru (Chikmagalur)" },
      { _id: "ka-chitradurga", display_name: "Chitradurga" },
      { _id: "ka-dakshina-kannada", display_name: "Dakshina Kannada" },
      { _id: "ka-davanagere", display_name: "Davanagere" },
      { _id: "ka-dharwad", display_name: "Dharwad" },
      { _id: "ka-gadag", display_name: "Gadag" },
      { _id: "ka-hassan", display_name: "Hassan" },
      { _id: "ka-haveri", display_name: "Haveri" },
      { _id: "ka-kalaburagi", display_name: "Kalaburagi (Gulbarga)" },
      { _id: "ka-kodagu", display_name: "Kodagu (Coorg)" },
      { _id: "ka-kolar", display_name: "Kolar" },
      { _id: "ka-koppal", display_name: "Koppal" },
      { _id: "ka-mandya", display_name: "Mandya" },
      { _id: "ka-mysuru", display_name: "Mysuru (Mysore)" },
      { _id: "ka-raichur", display_name: "Raichur" },
      { _id: "ka-ramanagara", display_name: "Ramanagara" },
      { _id: "ka-shivamogga", display_name: "Shivamogga (Shimoga)" },
      { _id: "ka-tumakuru", display_name: "Tumakuru (Tumkur)" },
      { _id: "ka-udupi", display_name: "Udupi" },
      { _id: "ka-uttara-kannada", display_name: "Uttara Kannada (Karwar)" },
      { _id: "ka-vijayapura", display_name: "Vijayapura (Bijapur)" },
      { _id: "ka-yadgir", display_name: "Yadgir" },
      { _id: "ka-vijayanagara", display_name: "Vijayanagara" }
    ]
  };
  
  
  const [fromState, setFromState] = useState("");
  const [toState, setToState] = useState("");
    
    const handleFareChange = (e) => {
        setState(prev => ({
            ...prev,
            fare: parseFloat(e.target.value) || 0
        }));
        
    };
    const [totalPrice, setTotalPrice] = useState(0);

    useEffect(() => {
      const distance = parseFloat(state.distance);
      const fare = parseFloat(state.fare);
    
      const finalDistance = !isNaN(distance) ? distance : 0;   // No default if not entered
      const finalFare = !isNaN(fare) ? fare : 0;               // No default if not entered
    
      const perKmRate = 35;
      const total = (finalDistance * perKmRate) + finalFare;
    
      setTotalPrice(total);
    }, [state.distance, state.fare]);
        // // Calculate total fare
    // const totalPrice = (state.distance * state.fare).toFixed(2);

     // ✨ Total Price = Distance + Fare
//   const totalPrices =
//     !isNaN(parseFloat(state.distance)) && !isNaN(parseFloat(state.fare))
//       ? (parseFloat(state.distance) + parseFloat(state.fare)).toFixed(2)
//       : '0.00';

    

    return (
        <div className="container form-section">
            <div className="row search-call">
                <div className=" col-md-4 form-left " style={{ backgroundColor: "#005395" }} >
                    <h3>Call Now !</h3>
                    <div className="row">
                        <div className="col-2 phone-icons mt-4">
                            <i className="fa-solid fa-phone" style={{ fontSize: "40px", padding: "8px", color: "white", textAlign: "start" }}></i>
                        </div>
                        <div className=" col-10 callDetails">
                            <h6>Call for detail information</h6>
                            <h2>9994074471</h2>
                        </div>
                    </div>
                </div>
                <div className=" col-md-8 form-right" style={{ backgroundColor: "white" }}>
                    <form className='container-fluid booking-form' onSubmit={FormSubmit}>
                        <div className='row triptype'>
                        <div className='col-4 from-input trip-type-btn'>
                                <button
                                    type='button'
                                    className={`${state.triptype === 'Outstation' ? "active" : ""}`}
                                    value="Outstation"
                                    onClick={(e) => { dispatch({ type: "TRIP-TYPE", payload: e.target.value }) }}>Out Station
                                </button>
                                {/* <input
                                    type="radio"
                                    id='Outstation'
                                    name='trip-type'
                                    value="Outstation"
                                    onChange={(e) => { dispatch({ type: "TRIP-TYPE", payload: e.target.value }) }}
                                /> 
                                <label htmlFor="Outstation">Outstation</label>*/}
                            </div>
                            <div className='col-4 from-input trip-type-btn'>
                                <button
                                    type='button'
                                    className={`${state.triptype === 'Local Trip' ? "active" : ""}`}
                                    value="Local Trip"
                                    onClick={(e) => { dispatch({ type: "TRIP-TYPE", payload: e.target.value }) }}>Local Trip
                                </button>
                                {/* <input
                                    type="radio"
                                    id='Local-Trip'
                                    name='trip-type'
                                    value="Local Trip"
                                    onChange={(e) => { dispatch({ type: "TRIP-TYPE", payload: e.target.value }) }}
                                /> 
                                <label htmlFor="Local-Trip">Local Trip</label>*/}
                            </div>
                            <div className='col-4 from-input trip-type-btn'>
                                <button
                                    type='button'
                                    className={`${state.triptype === 'Drop Trip' ? "active" : ""}`}
                                    value="Drop Trip"
                                    onClick={(e) => { dispatch({ type: "TRIP-TYPE", payload: e.target.value }) }}>Drop Trip
                                </button>

                                {/* <input
                                    type="radio"
                                    id='Drop-Trip'
                                    name='trip-type'
                                    value="Drop Trip"

                                    onChange={(e) => { dispatch({ type: "TRIP-TYPE", payload: e.target.value }) }}
                                />
                                <label htmlFor="Drop-Trip">Drop Trip</label> */}
                            </div>
                        </div>

                        {error && (
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <p style={{ color: 'red', fontSize: "12px" }} >{error}</p>
                                </div>
                            </div>
                        )}

<div className={`row ${error ? "mt-0" : "mt-4"}`}>
  <div className='col-6'>
    <label>From State</label>
    <select className='input-field' value={fromState} onChange={e => setFromState(e.target.value)} required>
      <option value="">Select State</option>
      {Object.keys(statesWithCities).map(state => (
        <option key={state} value={state}>{state}</option>
      ))}
    </select>

    {fromState && (
      <>
        <label htmlFor="From">From City</label>
        <select
          className='input-field'
          id='From'
          value={state.from}
          required
          onChange={(e) => dispatch({ type: "FROM", payload: e.target.value })}
        >
          <option value="">Select City</option>
          {statesWithCities[fromState].map(city => (
            <option key={city._id} value={city._id}>{city.display_name}</option>
          ))}
        </select>
      </>
    )}
  </div>

  <div className='col-6'>
    <label>To State</label>
    <select className='input-field' value={toState} onChange={e => setToState(e.target.value)} required>
      <option value="">Select State</option>
      {Object.keys(statesWithCities).map(state => (
        <option key={state} value={state}>{state}</option>
      ))}
    </select>

    {toState && (
      <>
        <label htmlFor="To">To City</label>
        <select
          className='input-field'
          id='To'
          value={state.to}
          required
          onChange={(e) => dispatch({ type: "TO", payload: e.target.value })}
        >
          <option value="">Select City</option>
          {statesWithCities[toState].map(city => (
            <option key={city._id} value={city._id}>{city.display_name}</option>
          ))}
        </select>
      </>
    )}
  </div>
</div>




                        <div className='row mt-3'>
                            <div className='col-4'>
                                <label htmlFor="PickUpLoaction">Pick Up Loaction</label>
                                <input type="text" className='input-field'
                                    id='PickUpLoaction'
                                    value={state.pickUpLocation}
                                    placeholder=""
                                    required
                                    onChange={(e) => { dispatch({ type: "PICK-UP-LOCATION", payload: e.target.value }) }} />
                            </div>

                            <div className='col-4'>
                                <label htmlFor="Date">Pick Up Date</label> <br />
                                <Datepicker className='input-field'
                                    selected={state.PickUpdate}
                                    required
                                    onChange={(date) => { dispatch({ type: "PICK-UP-DATE", payload: date }) }} />
                            </div>

                            <div className='col-4'>
                                <label htmlFor="PickUpTime">Pick Up Time</label> <br />
                                <input type="time" className='input-field'
                                    id='PickUpTime'
                                    value={state.pickUpTime}
                                    placeholder="10.00 am"
                                    onChange={(e) => dispatch({ type: "PICK-UP-TIME", payload: e.target.value })}
                                />
                            </div>

                        </div>

                        {state.triptype === "Outstation" && (
                            <>
                                <div className='row mt-3'>
                                    <div className="col-12">
                                        <label htmlFor="Visiting Places">Visiting Places</label>
                                        {state.visitingPlaces.map((place, index) => (
                                            <div className='row mb-2' key={index}>
                                                <div className="col-8">
                                                    <input
                                                        type="text"
                                                        className='input-field'
                                                        value={place}

                                                        onChange={(e) => dispatch({ type: "UPDATE-VISITING-PLACE", payload: { index, value: e.target.value } })}
                                                    />
                                                </div>
                                                <div className='col-4'>
                                                    <button className='visiting-pl-add' type='button' onClick={() => dispatch({ type: "ADD-VISITING-PLACE" })}>+</button>
                                                    <button className='visiting-pl-delete' type='button' onClick={() => dispatch({ type: "REMOVE-VISITING-PLACE", payload: index })}>x</button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>


                            </>


                        )}



                        {(state.triptype === "Local Trip" || state.triptype === "Outstation") && (
                            <div className='row mt-3'>
                                <div className='col-4'>
                                    <label htmlFor="returnLocation">Return Location <b style={{ fontSize: "12px" }}>(Distination is Garage) </b></label>
                                    <input type="text" className='input-field'
                                        id='DropLoaction'
                                        value={state.ReturnLocation}
                                        placeholder=""
                                        required
                                        onChange={(e) => { dispatch({ type: "RETURN-LOCATION", payload: e.target.value }) }} />
                                </div>

                                <div className='col-4'>
                                    <label htmlFor="Date">Return Date</label> <br />
                                    <Datepicker className='input-field'
                                        selected={state.returndate}
                                        required
                                        onChange={(date) => { dispatch({ type: "RETURN-DATE", payload: date }) }} />
                                </div>

                                <div className='col-4'>
                                    <label htmlFor="ReturnTime">Return Time</label>
                                    <input type="time" className='input-field'
                                        id='ReturnTime'
                                        value={state.ReturnTime}
                                        placeholder='2.00 pm'
                                        required
                                        onChange={(e) => dispatch({ type: "RETURN-TIME", payload: e.target.value })} />
                                </div>
                            </div>
                        )}

                        {state.triptype === "Local Trip" && (
                            <div className='row mt-3'>
                                <div className='col-10'>
                                    <label htmlFor="LocalTripType">Select Trip Type</label>
                                    <select
                                        id='LocalTripType'
                                        className='input-field'
                                        value={state.LocalTripType}
                                        required
                                        onChange={(e) => { dispatch({ type: "LOCAL-TRIP-TYPE", payload: e.target.value }) }}
                                    >
                                        <option value="Hour-Basis">Hour-Basis</option>
                                        <option value="Day-Use">Day-Use</option>

                                    </select>
                                </div>
                            </div>
                        )

                        }

                        <div className='row mt-3'>
                            <div className='col-6'>
                                <label htmlFor="NumberOfPersons">Number Of Persons</label>
                                <input type="text" className='input-field'
                                    id='NumberOfPersons'
                                    value={state.NumberOfPersons}
                                    placeholder="4"
                                    required
                                    onChange={(e) => { dispatch({ type: "NUMBER-OF-PERSONS", payload: e.target.value }) }} />
                            </div>

                            {/* <div className='col-6'>
                                <label htmlFor="Distance">Distance <b style={{ fontSize: "12px" }}>({state.from} - {state.to} in km)</b></label>
                                <input type="number" className='input-field'
                                    id='Distance'
                                    value={state.distance}
                                    placeholder=""
                                    required
                                    onChange={handleDistanceChange}
                                />
                            </div> */}
                            {/* <div className='col-6'>
  <label htmlFor="Distance">
    Distance <b style={{ fontSize: "12px" }}>({state.from} - {state.to} in km)</b>
  </label>
  <input
    type="number"
    className='input-field'
    id='Distance'
    value={state.distance}
    placeholder=""
    required
    onChange={handleDistanceChange}
    disabled={state.triptype === 'Outstation'}
  />
</div> */}
{/* <div className='col-6'>
  <label htmlFor="Distance">
    Distance (in km)
  </label>
  <input
    type="number"
    className='input-field'
    id='Distance'
    value={state.distance}
    placeholder="Enter distance in km"
    required
    onChange={(e) =>
      dispatch({ type: "DISTANCE", payload: e.target.value })
    }
    disabled={state.triptype === 'Outstation'}
  />
</div> */}

<div className='col-5'>
  <label htmlFor="Distance">Distance (in km)</label>
  <input
    type="number"
    className='input-field'
    id='Distance'
    value={state.distance || ''}  
    placeholder="Enter distance in km"
    required
    onChange={(e) => {
      // Dispatching the value only when the user interacts with the field
      dispatch({ type: "DISTANCE", payload: e.target.value });
    }}
  />
  <small className="form-text text-muted">
    Please enter the distance in kilometers (km) for the trip.
  </small>
</div>








                        </div>



                        {/* <div className='row mt-3'> */}

                            <SelectCab state={state} dispatch={dispatch} />
                            {/* <div className='col-6'>

                                     <label htmlFor="CabType">Cab Type</label> <br />
                                        <select
                                            id='CabType'
                                            className='input-field'
                                            value={state.CabType}
                                            required
                                            onChange={(e) => { dispatch({ type: "CAB-TYPE", payload: e.target.value }) }}
                                        >
                                            <option>3 Seater</option>
                                            <option>4 Seater</option>
                                            <option>5 Seater</option>
                                            <option>6 Seater</option>
                                        </select>

                                    </div> */}
                            {/* <div className='col-6'>
                                        <label htmlFor="Fare">Fare (Rs)</label>
                                        <input type="text" className='input-field'
                                            id='Fare'
                                            value={state.fare}
                                            readOnly
                                        />
                                        <p style={{color:"black"}}>{state.fare}</p>
                                    </div>

                        </div>
                        <div className="row"> */}
            {/* Distance Input */}
            {/* <div className='col-6'>
                <label htmlFor="Distance">
                    Distance <b style={{ fontSize: "12px" }}>({state.from} - {state.to} in km)</b>
                </label>
                <input
                    type="number"
                    className='input-field'
                    id='Distance'
                    value={state.distance}
                    placeholder="Enter distance"
                    required
                    onChange={handleDistanceChange}
                />
            </div> */}

            {/* Fare Input */}
            {/* <div className='col-6'>
                <label htmlFor="Fare">Fare </label>
                <input
                    type="number"
                    className='input-field'
                    id='Fare'
                    value={state.fare}
                    placeholder="Enter fare per km"
                    required
                    onChange={handleFareChange}
                />
            </div> */}
            {/* <div className='col-6'>
  <label htmlFor="Fare">Fare (₹ per km)</label>
  <input
    type="number"
    className='input-field'
    id='Fare'
    value={state.fare}
    required
    onChange={(e) => dispatch({ type: 'FARE', payload: e.target.value })}
  />
</div> */}


            {/* Fare Summary Table */}
            
            <div className='col-12 mt-4'>
  <h5>Total Price Summary</h5>
  <table className="table table-bordered">
    <thead>
      <tr>
        <th>From</th>
        <th>To</th>
        <th>Distance (km)</th>
        {/* <th>Fare (₹)</th> */}
        <th>Total Price (₹)</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{state.from}</td>
        <td>{state.to}</td>
        <td>{state.distance}</td>
        {/* <td>{state.fare}</td> */}
        <td>₹ {totalPrice.toFixed(2)}</td>
      </tr>
    </tbody>
  </table>
</div>





                        <div className='row mt-4'>
                            <div className="col-12 agree-tc">
                                <input type="checkbox"
                                    required />
                                <label>I agree to the terms & conditions of SAP Travels</label>
                            </div>

                        </div>

                        <div className='row mt-4'>
                            <div className="col-12 search-cab">
                                <button type='submit'>Book Now</button>
                            </div>
                        </div>
                    </form>
                    <Link to="/terms&conditions">
                        <p className='fare-explanation' style={{ color: "black", marginTop: "-20px", fontSize: "10px", textAlign: "right" }}>
                            Terms & conditions Applicable
                        </p>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default BookingForm;